import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Login from "./views/Login";
import DefinePassword from "./views/DefinePassword";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import Account from "./views/Account";
import Dashboard from "./views/Dashboard";
import Stores from "./views/Stores";
import Lockers from "./views/Lockers";
import Monitoring from "./views/Monitoring";
import Users from "./views/Users";
import Products from "./views/Products";
import ProductCreation from "./views/ProductCreation";
import ScaleProducts from "./views/ScaleProducts";
import Transactions from "./views/Transactions";
import Settlements from "./views/Settlements";
import Accesses from "./views/Accesses";
import Vendings from "./views/Vendings";
import VendingCategories from "./views/VendingCategories";
import Feedbacks from "./views/Feedbacks";
import Purchases from "./views/Purchases";
import Configs from "./views/Configs";
import Credits from "./views/Credits";
import InventoriesAndRefills from "./views/InventoriesAndRefills";
import ProductLogs from "./views/ProductLogs";
import Operators from "./views/Operators";
import LockerDeliveries from "./views/LockerDeliveries";
import Orders from "./views/Orders";
import BuyNowPayLater from "./views/BuyNowPayLater";
import PurchasesInvoices from "./views/PurchasesInvoices";
import Bags from "./views/Bags.vue";
import Stockouts from "./views/Stockouts.vue";
import ClientCoupon from "./views/ClientCoupon";
import InvoicesPack from "./views/InvoicesPack";
import Clients from "./views/Clients";
import Courses from "./views/Courses";
import Billing from "./views/Billing";
import Totems from "./views/Totems";
import Ferramentas from "./views/Ferramentas.vue";
import Simulador from "./views/Simulador.vue";
import PendingExternalProducts from "./views/PendingExternalProducts.vue";
import RewardProgram from "./views/RewardProgram.vue";

// prevent NavigationDuplicated error
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      beforeEnter: logout
    },
    {
      path: "/forgot-password",
      name: "forgotpassword",
      component: ForgotPassword,
      beforeEnter: logout
    },
    {
      path: "/define-password",
      name: "define-password",
      component: DefinePassword,
      beforeEnter: logout
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: ResetPassword,
      beforeEnter: logout
    },
    {
      path: "/account",
      name: "account",
      component: Account,
      beforeEnter: checkAuth
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      beforeEnter: checkAuth
    },
    {
      path: "/dashboard-new",
      redirect: "/dashboard"
    },
    {
      path: "/stores",
      name: "stores",
      component: Stores,
      beforeEnter: checkAuth
    },
    {
      path: "/lockers",
      name: "lockers",
      component: Lockers,
      beforeEnter: checkAuth
    },
    {
      path: "/monitoring",
      name: "monitoring",
      component: Monitoring,
      beforeEnter: checkAuth
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      beforeEnter: checkAuth
    },
    {
      path: "/purchases",
      name: "purchases",
      component: Purchases,
      beforeEnter: checkAuth
    },
    {
      path: "/products",
      name: "products",
      component: Products,
      beforeEnter: checkAuth
    },
    {
      path: "/inventories-refills",
      name: "inventories-refills",
      component: InventoriesAndRefills,
      beforeEnter: checkAuth
    },
    {
      path: "/product-logs",
      name: "product-logs",
      component: ProductLogs,
      beforeEnter: checkAuth
    },
    {
      path: "/product-creation",
      name: "product-creation",
      component: ProductCreation,
      beforeEnter: checkAuth
    },
    {
      path: "/scale-products",
      name: "scale-products",
      component: ScaleProducts,
      beforeEnter: checkAuth
    },
    {
      path: "/transactions",
      name: "transactions",
      component: Transactions,
      beforeEnter: checkAuth
    },
    {
      path: "/settlements",
      name: "settlements",
      component: Settlements,
      beforeEnter: checkAuth
    },
    {
      path: "/vendings",
      name: "vendings",
      component: Vendings,
      beforeEnter: checkAuth
    },
    {
      path: "/vending-categories",
      name: "vending-categories",
      component: VendingCategories,
      beforeEnter: checkAuth
    },
    {
      path: "/accesses",
      name: "accesses",
      component: Accesses,
      beforeEnter: checkAuth
    },
    {
      path: "/feedbacks",
      name: "feedbacks",
      component: Feedbacks,
      beforeEnter: checkAuth
    },
    {
      path: "/configs",
      name: "configs",
      component: Configs,
      beforeEnter: checkAuth
    },
    {
      path: "/credits",
      name: "credits",
      component: Credits,
      beforeEnter: checkAuth
    },
    {
      path: "/operators",
      name: "operators",
      component: Operators,
      beforeEnter: checkAuth
    },
    {
      path: "/locker-deliveries",
      name: "locker-deliveries",
      component: LockerDeliveries,
      beforeEnter: checkAuth
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      beforeEnter: checkAuth
    },
    {
      path: "/buy-now-pay-later",
      name: "buy-now-pay-later",
      component: BuyNowPayLater,
      beforeEnter: checkAuth
    },
    {
      path: "/purchases-invoices",
      name: "purchases-invoices",
      component: PurchasesInvoices,
      beforeEnter: checkAuth
    },
    {
      path: "/bags",
      name: "bags",
      component: Bags,
      beforeEnter: checkAuth
    },
    {
      path: "/totems",
      name: "totems",
      component: Totems,
      beforeEnter: checkAuth
    },
    {
      path: "/stockouts",
      name: "stockouts",
      component: Stockouts,
      beforeEnter: checkAuth
    },
    {
      path: "/ferramentas",
      name: "ferramentas",
      component: Ferramentas,
      beforeEnter: checkAuth
    },
    {
      path: "/simulador",
      name: "simulador",
      component: Simulador,
      beforeEnter: checkAuth
    },
    {
      path: "/pending-external-products",
      name: "pending-external-products",
      component: PendingExternalProducts,
      beforeEnter: checkAuth
    },
    {
      path: "/reward-program",
      name: "reward-program",
      component: RewardProgram,
      beforeEnter: checkAuth
    },
    {
      path: "/coupon",
      name: "coupon",
      component: ClientCoupon
    },
    {
      path: "/invoices-pack",
      name: "invoices-pack",
      component: InvoicesPack
    },
    {
      path: "/courses",
      name: "courses",
      component: Courses
    },
    {
      path: "/clients",
      name: "clients",
      component: Clients
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

function checkAuth(to, from, next) {
  if (!store.getters.isAuthenticated) {
    next("/");
  } else if (
    (to.path === "/monitoring" &&
      !store.getters.merchantHasOpenMartCameraMonitoring) ||
    (to.path === "/products" && !store.getters.permissions.seeProducts) ||
    (to.path === "/product-creation" &&
      !store.getters.permissions.createProducts) ||
    (to.path === "/purchases" && !store.getters.permissions.seePurchases) ||
    (to.path === "/users" && !store.getters.permissions.seeBlockedClients) ||
    (to.path === "/accesses" && !store.getters.permissions.seeAccessesPage) ||
    (to.path === "/transactions" &&
      !store.getters.permissions.seeTransactionsPage) ||
    (to.path === "/settlements" && !store.getters.permissions.seeSettlements) ||
    (to.path === "/operators" && !store.getters.permissions.manageOperators) ||
    (to.path === "/credits" && !store.getters.permissions.seeCashbacks) ||
    (to.path === "/feedbacks" && !store.getters.permissions.seeFeedbacksPage) ||
    (to.path === "/configs" && !store.getters.permissions.seeStoreConfigs) ||
    (to.path === "/orders" && !store.getters.permissions.seeOrders) ||
    (to.name === "purchases-invoices" &&
      !store.getters.permissions.canSeePurchasesInvoices) ||
    (to.path === "/bags" &&
      !store.getters.permissions.canManageBag &&
      !store.getters.permissions.canManageBagProducts) ||
    (to.path === "/reward-program" &&
      !["oniiFranchise", "mq"].includes(store.getters.companyInfo.contract))
    // (to.path === "/buy-now-pay-later" &&
    //   !store.getters.permissions.seeBuyNowPayLater)
  ) {
    next("/dashboard");
  } else {
    next();
  }
}

function logout(to, from, next) {
  store.dispatch("clearAccountData");
  store.dispatch("clearStores");
  store.dispatch("clearPurchases");
  store.dispatch("setStoreBeingManaged", null);
  store.dispatch("setLockerBeingManaged", null);
  store.dispatch("logout");
  next();
}
